export default "/biometrie-afghanistan/media/2cba956ca1dc715cb14138e83de5aa5c~header-1020w.jpg";